import styled from 'styled-components';

const _SVGButton = styled.span`
  padding: 5px;
  background: #f7f7f7;
  border-radius: 5px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  cursor: pointer;
  
  &:hover {
    background: #fafafa;
  }

  &:not(:first-of-type) {
    margin-left: 5px;
  }

  svg {
    min-width: 30px;
  }

  path {
    fill: ${props => props.fill ? props.fill : '#ccc'};
    stroke: none;
  }
`

export default _SVGButton;


// WEBPACK FOOTER //
// ./src/components/common/styled-svg-button.js